export default {
  // START:: SET APP LOCALE
  setAppLocale(state, payload) {
    state.glow_up_dashboard_language = payload;
  },
  // END:: SET APP LOCALE
};
